module.exports = __webpack_public_path__ + "static/img/nosearch.e98f7b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/search/nosearch.png
// module id = 4Y6G
// module chunks = 1